import React from 'react';
import {LEAVE, PAGINATION} from "../../common/constant";
import {sendData} from "../actions";
import moment from "moment";
import {localToIST} from "ubs-framework/v2/common/date";
import {getCurrentFinancialYear} from "../../common/functions/common";
import {monthEnd, monthStart} from "./filters";

export const prevMonthStart = new Date(new Date(moment().set('month', new Date().getMonth() - 1).startOf('month'))).getTime()
export const nextMonthEnd = new Date(new Date(moment().set('month', new Date().getMonth() + 1).endOf('month'))).getTime()
const initialState = {
    socketId: '',
    userLeaveFilter: {year: new Date().getFullYear(), financialYear: getCurrentFinancialYear()},
    userLeaveBalance: [],
    leaveUser: null,
    userLeaveBalanceDataLoading: true,

    userUpcomingLeave: [],
    userUpcomingLeaveDataLoading: true,
    userUpcomingHoliday: [],
    userUpcomingHolidayDataLoading: true,

    leaveHistoryList: [],
    leaveHistoryDataLoading: true,
    leaveHistoryTotalRecords: 0,
    leaveHistory: {
        year: new Date().getFullYear(), // Number | required
        status: 0, // Number | required | [0 | 1 | 2 | 3 | 4] [ALL | PENDING | APPROVED | REJECTED | CANCELLED]
        search: '', // String | optional
        leaveType: '', // ObjectId | optional
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        sort: {createdAt: 1}
    },
    encashmentHistory: {
        year: new Date().getFullYear(), // Number | required
        status: 0, // Number | required | [0 | 1 | 2 | 3 | 4] [ALL | PENDING | APPROVED | REJECTED | CANCELLED]
        search: '', // String | optional
        leaveType: '', // ObjectId | optional
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        sort: {createdAt: 1}
    },

    leaveAdjustmentList: [],
    leaveAdjustmentDataLoading: true,
    leaveAdjustmentTotalRecords: 0,
    leaveAdjustment: {
        users: [],
        currentPage: PAGINATION.CURRENT_PAGE,
        isShowDeletedAdjustment: false,
        limit: PAGINATION.LIMIT,
        from: prevMonthStart, // Number | required
        to: nextMonthEnd, // Number | required
        // sort: {createdAt: 1}
    },

    leaveType: [],
    leavePolicyList: [],
    leaveSettingData: null,
    summery: null,
    summeryDataLoading: true,

    leaveApplications: [],
    encashmentSelect: [],
    leaveApplicationsTotalRecords: 0,
    leaveApplicationsLoading: true,
    leaveApplicationsFilter: {
        date: {
            startDate: prevMonthStart, // Number | required
            endDate: nextMonthEnd // Number | required
        },
        status: LEAVE.leaveStatus[0], // Number | required | [0 | 1 | 2 | 3 | 4] [ALL | PENDING | APPROVED | REJECTED | CANCELLED]
        limit: PAGINATION.LIMIT, // Number | required
        currentPage: PAGINATION.CURRENT_PAGE,// Number | required
        sort: {from: -1},
    },
    encashmentApplicationsFilter: {
        from: prevMonthStart, // Number | required
        to: nextMonthEnd, // Number | required
        status: 1, // Number | required | [0 | 1 | 2 | 3 | 4] [ALL | PENDING | APPROVED | REJECTED | CANCELLED]
        leaveType: '', // ObjectId | optional
        limit: PAGINATION.LIMIT, // Number | required
        currentPage: PAGINATION.CURRENT_PAGE,// Number | required
        search: '', // String | optional
        sort: {from: -1},
        filter: {}
    },

    leaveCalenderFilter: {
        from: null, // Number | required
        to: null, // Number | required
        status: 0, // Number | required | [0 | 1 | 2 | 3 | 4] [ALL | PENDING | APPROVED | REJECTED | CANCELLED]
        leaveType: '', // ObjectId | optional
        limit: PAGINATION.LIMIT, // Number | required
        currentPage: PAGINATION.CURRENT_PAGE,// Number | required
        search: '', // String | optional
        sort: {from: -1},
        month: new Date()?.getMonth() + 1,
        filter: {}
    },

    leaveBalance: [],
    leaveBalancePolicies: [],
    leaveBalanceDataLoading: true,
    leaveBalanceTotalRecords: 0,
    leaveBalanceFilter: {
        year: {value: new Date().getFullYear(), label: new Date().getFullYear()} , //* @param - year - Number | required
        financialYear: {value: getCurrentFinancialYear(), label: getCurrentFinancialYear()} , //* @param - from | to - Number | required
        limit: 20, // * @param - limit - Number | required
        currentPage: PAGINATION.CURRENT_PAGE, // * @param - currentPage - Number | required
        type: {value: 'active', label: 'Active Employees'},
    },
    assignDonateLeave: null,
    getLeaveBankCount: null,
    donatedLeaveFilter:{
        search: '',
        limit: 20,
        currentPage: PAGINATION.CURRENT_PAGE,
        users:[],
        type: 2,
        filter: {
            startDate: monthStart,
            endDate: monthEnd
        }
    }
};


export default function (state = initialState, action) {
    switch (action.type) {
        case 'SOCKET_CONNECTION': {
            return {...state, socketId: action.payload};
        }
        case 'FILTER_USER_LEAVE': {
            return {
                ...state,
                userLeaveFilter: {...state.userLeaveFilter, ...action.payload},
                userLeaveBalanceDataLoading: true
            }
        }
        case 'FILTER_USER_LEAVE_LOADING': {
            return {...state, userLeaveBalanceDataLoading: action.payload, leaveUser: null, userLeaveBalance: []}
        }
        case 'SET_USER_LEAVE_BALANCE': {
            action.payload.leaveBalance.map(e => {
                e.label = e.leaveType.name
                e.value = e.leaveType._id
                return e
            })
            return {
                ...state,
                userLeaveBalance: action.payload.leaveBalance,
                leaveUser: action.payload.userInfo,
                userLeaveBalanceDataLoading: false
            }
        }
        case 'SET_USER_UPCOMING_LEAVE': {
            return {
                ...state,
                userUpcomingLeave: action.payload.leaveApplications || [],
                userUpcomingLeaveDataLoading: false
            }
        }
        case 'SET_USER_UPCOMING_HOLIDAY': {
            return {...state, userUpcomingHoliday: action.payload.holidays || [], userUpcomingHolidayDataLoading: false}
        }
        case 'GET_LEAVE_SETTING_DATA': {
            return {...state, leaveSettingData: action.payload || null}
        }
        case 'FILTER_LEAVE_HISTORY': {
            sendData('hrms|leave|application|myHistory', {...state.leaveHistory, ...action.payload});
            return {...state, leaveHistory: {...state.leaveHistory, ...action.payload}, leaveHistoryDataLoading: true}
        }
        case 'FILTER_ENCASHMENT_HISTORY': {
            return {...state, encashmentHistory: {...state.encashmentHistory, ...action.payload},}
        }
        case 'SET_MY_LEAVE_HISTORY': {
            const localState = {leaveHistoryList: action.payload.list, leaveHistoryDataLoading: false}
            if (typeof action.payload.totalRecords === 'number') localState.leaveHistoryTotalRecords = action.payload.totalRecords
            return {...state, ...localState}
        }

        case 'SET_MY_ENCASHMENT_HISTORY': {
            const localState = {leaveHistoryList: action.payload.list, leaveHistoryDataLoading: false}
            if (typeof action.payload.totalRecords === 'number') localState.leaveHistoryTotalRecords = action.payload.totalRecords
            return {...state, ...localState}
        }

        case 'FILTER_LEAVE_ADJUSTMENT': {
            const data = {...state.leaveAdjustment, ...action.payload, filter:{}}
            data.from = localToIST(data?.from)
            data.to = localToIST(data?.to, 'end')
            if (data?.location) data.filter.location = [data?.location];
            delete data.location
            if (data?.department) data.filter.department = [data?.department];
            delete data.department
            if (data?.jobTitle) data.filter.jobTitle = [data?.jobTitle];
            delete data.jobTitle
            if (data?.companyId) data.filter.companyId = [data?.companyId];
            delete data.companyId
            sendData('hrms|leaveBalance|adjustment|read', data);
            return {
                ...state,
                leaveAdjustment: {...state.leaveAdjustment, ...action.payload},
                leaveAdjustmentDataLoading: true
            }
        }
        case 'SET_LEAVE_ADJUSTMENT': {
            const localState = {leaveAdjustmentList: action.payload.list, leaveAdjustmentDataLoading: false}
            if (typeof action.payload.totalRecords === 'number') localState.leaveAdjustmentTotalRecords = action.payload.totalRecords
            return {...state, ...localState}
        }

        case 'SET_LEAVE_TYPE': {
            action.payload.leaveTypes.map(e => {
                e.label = e.name
                e.value = e._id
                return e
            })
            return {...state, leaveType: action.payload.leaveTypes}
        }

        case 'SET_LEAVE_POLICY_LIST': {
            let leavePolicyList = []
            action.payload?.map( e => {
                leavePolicyList = leavePolicyList?.concat(e?.policies || [])
            });
            return {...state, leavePolicyList}
        }

        case 'SET_LEAVE_APPLICATION_SUMMERY': {
            return {...state, summery: action.payload, summeryDataLoading: false}
        }
        case 'ASSIGN_DONATE_LEAVE': {
            return {...state, assignDonateLeave: action.payload}
        }
        case 'DONATED_LEAVE_FILTER': {
            return {...state, donatedLeaveFilter: action.payload}
        }
        case 'GET_LEAVE_BANK_COUNT': {
            return {...state, getLeaveBankCount: action.payload}
        }
        case 'UPDATE_LEAVE_APPLICATION_SUMMERY': {
            return {...state, summery: {...state.summery, ...action.payload}}
        }
        case 'FILTER_LEAVE_APPLICATION': {
            return {...state, leaveApplicationsFilter: {...state.leaveApplicationsFilter, ...action.payload}}
        }

        case 'FILTER_ENCASHMENT_APPLICATION': {
            const data = {...state.encashmentApplicationsFilter, ...action.payload, filter: {}}
            data.from = localToIST(data?.from)
            data.to = localToIST(data?.to, 'end')
            if(data.department) data.filter.department = [data.department]
            if(data.location) data.filter.location = [data.location]
            if(data.category) data.filter.category = [data.category]
            if(data.subLocation) data.filter.subLocation = [data.subLocation]
            if (data.businessUnit) data.filter.businessUnit = [data.businessUnit]
            if (data.costCenter) data.filter.costCenter = [data.costCenter]
            if (data.workArea) data.filter.workArea = [data.workArea]
            if (data.bands) data.filter.bands = data.bands?.map((item)=> item?._id)
            if (data.grade) data.filter.grade = [data.grade?.value]
            if (data.segment) data.filter.segment = [data.segment]
            if (data.hub) data.filter.hub = [data.hub]
            if (data.region) data.filter.region = [data.region]
            if (data.territory) data.filter.territory = [data.territory]
            delete data.department
            delete data.location
            delete data.category
            delete data.subLocation
            delete data.businessUnit
            delete data.costCenter
            delete data.bands
            delete data.segment
            delete data.hub
            delete data.region
            delete data.territory
            delete data.grade
            delete data.workArea
            data.users = data?.users?.value ? [data?.users?.value] : []
            return {...state, encashmentApplicationsFilter: {...state.encashmentApplicationsFilter, ...action.payload}}
        }
        case 'FILTER_LEAVE_CALENDER': {
            const data = {...state.leaveCalenderFilter, ...action.payload, filter: {}}
            data.from = localToIST(data?.from)
            data.to = localToIST(data?.to, 'end')
            if(data.department) data.filter.department = [data.department]
            if(data.location) data.filter.location = [data.location]
            if(data.category) data.filter.category = [data.category]
            delete data.department
            delete data.location
            delete data.category
            data.users = data?.users?.value ? [data?.users?.value] : []
            return {...state, leaveCalenderFilter: {...state.leaveCalenderFilter, ...action.payload}}
        }
        case 'SET_LEAVE_APPLICATIONS': {
            const localState = {leaveApplications: action.payload.leaveApplications, leaveApplicationsLoading: false}
            if (typeof action.payload.totalRecords === 'number') localState.leaveApplicationsTotalRecords = action.payload.totalRecords
            return {...state, ...localState}
        }
        case 'SET_ENCASHMENT_SELECT': {
            let localState = {encashmentSelect: action.payload.encashmentSelect}
            return {...state, ...localState}
        }
        case 'UPDATE_LEAVE_APPLICATIONS_COUNT': {
            const localState = {}
            let leaveApplications = JSON.parse(JSON.stringify(state.leaveApplications))
            if (action.payload.referenceId) {
                const j = leaveApplications.findIndex(e => e._id === action.payload.referenceId)
                if (j !== -1) {
                    leaveApplications[j].unreadCount = action.payload.unreadCount
                    localState.leaveApplications = leaveApplications
                }
            }
            return {...state, ...localState}
        }
        case 'UPDATE_LEAVE_APPLICATIONS': {
            const localState = {}

            let leaveApplications = JSON.parse(JSON.stringify(state.leaveApplications))
            const i = leaveApplications.findIndex(e => e._id === action.payload.leaveType._id)
            if (i !== -1) {
                if (state.leaveApplicationsFilter.status === action.payload.leaveType.status || state.leaveApplicationsFilter.status === 0) {
                    localState.leaveApplications = leaveApplications.map(e => {
                        if (e._id === action.payload.leaveType._id) {
                            e.actionComment = action.payload.leaveType.actionComment
                            e.from = action.payload.leaveType.from
                            e.leaveDays = action.payload.leaveType.leaveDays
                            if (typeof action.payload.leaveType.leavePolicy === "object") e.leavePolicy = action.payload.leaveType.leavePolicy
                            if (typeof action.payload.leaveType.leaveType === "object") e.leaveType = action.payload.leaveType.leaveType
                            e.noReference = action.payload.leaveType.noReference
                            e.reason = action.payload.leaveType.reason
                            e.status = action.payload.leaveType.status
                            e.to = action.payload.leaveType.to
                            e.totalLeaveDays = action.payload.leaveType.totalLeaveDays
                        }
                        return e
                    })
                } else localState.leaveApplications = leaveApplications.filter(e => e._id !== action.payload.leaveType._id)
            }

            let leaveHistoryList = JSON.parse(JSON.stringify(state.leaveHistoryList))
            const j = leaveHistoryList.findIndex(e => e._id === action.payload.leaveType._id)
            if (j !== -1) {
                if (state.leaveHistory.status === action.payload.leaveType.status || state.leaveHistory.status === 0) {
                    leaveHistoryList = leaveHistoryList.map(e => {
                        if (e._id === action.payload.leaveType._id) e = {...e, ...action.payload.leaveType}
                        return e
                    })
                } else leaveHistoryList = leaveHistoryList.filter(e => e._id !== action.payload.leaveType._id)
                localState.leaveHistoryList = leaveHistoryList
            }

            let userUpcomingLeave = JSON.parse(JSON.stringify(state.userUpcomingLeave))
            const k = userUpcomingLeave.findIndex(e => e._id === action.payload.leaveType._id)
            if (k !== -1) {
                if (action.payload.leaveType.status === 1 || action.payload.leaveType.status === 2) {
                    userUpcomingLeave = userUpcomingLeave.map(e => {
                        if (e._id === action.payload.leaveType._id) e = {...e, ...action.payload.leaveType}
                        return e
                    })
                } else userUpcomingLeave = userUpcomingLeave.filter(e => e._id !== action.payload.leaveType._id)
                localState.userUpcomingLeave = userUpcomingLeave
            }


            return {...state, ...localState}
        }
        case 'UPDATE_LEAVE_HISTORY_COUNT': {
            const localState = {}
            let leaveHistoryList = JSON.parse(JSON.stringify(state.leaveHistoryList))
            if (action.payload.referenceId) {
                const j = leaveHistoryList.findIndex(e => e._id === action.payload.referenceId)
                if (j !== -1) {
                    leaveHistoryList[j].unreadCount = action.payload.unreadCount
                    localState.leaveHistoryList = leaveHistoryList
                }
            }
            return {...state, ...localState}
        }
        case 'FILTER_LEAVE_BALANCE' : {
            return {
                ...state,
                leaveBalanceFilter: {...state.leaveBalanceFilter, ...action.payload},
                leaveBalanceDataLoading: true
            }
        }

        case 'SET_LEAVE_BALANCE': {
            const localState = {}
            action.payload.leavePolicies.map(e => {
                const leaveTypes = action.payload.leaveTypes.find(l => l._id === e.leaveType)
                if (leaveTypes) e.leaveType = leaveTypes
            })
            action.payload.leaveBalance.map(e => {
                e.balance.forEach(b => {
                    e[b.leavePolicy] = b
                })
                return e
            })
            localState.leaveBalancePolicies = action.payload.leavePolicies
            localState.leaveBalance = action.payload.leaveBalance
            localState.leaveBalanceDataLoading = false;
            if (action.payload.totalRecords) localState.leaveBalanceTotalRecords = action.payload.totalRecords
            return {...state, ...localState}
        }
        case 'UPDATE_LEAVE_BALANCE': {
            const localState = {}
            if (action.payload?.user === state.leaveUser?._id && action.payload?.year === state.userLeaveFilter?.year) {
                let userLeaveBalance = JSON.parse(JSON.stringify(state.userLeaveBalance))
                const i = state.userLeaveBalance.findIndex(e => e?.leavePolicy?._id === action.payload?.leavePolicy?._id)
                if (i < 0) {
                    action.payload.label = action.payload.leaveType.name
                    action.payload.value = action.payload.leaveType._id
                    userLeaveBalance.push(action.payload)
                } else {
                    userLeaveBalance = userLeaveBalance.map(e => {
                        if (e.leavePolicy._id === action.payload.leavePolicy._id) e = {...e, ...action.payload}
                        return e
                    })
                }

                localState.userLeaveBalance = userLeaveBalance
            }
            if (action.payload?.year === state.leaveBalanceFilter?.year?.value) {
                let leaveBalance = JSON.parse(JSON.stringify(state.leaveBalance))
                localState.leaveBalance = leaveBalance.map(e => {
                    if (e._id === action.payload.user) {
                        e.balance.map(b => {
                            if (b.leavePolicy === action.payload.leavePolicy._id) {
                                b.balance = action.payload?.balance || 0
                                b.planned = action.payload?.planned || 0
                                b.used = action.payload?.used || 0

                                e[b.leavePolicy].balance = action.payload?.balance || 0
                                e[b.leavePolicy].planned = action.payload?.planned || 0
                                e[b.leavePolicy].used = action.payload?.used || 0
                            }
                            return b
                        })
                    }
                    return e
                })
            }

            return {...state, ...localState}
        }
        case 'DELETE_USER_LEAVE_BALANCE': {
            const localState = {}
            if (action.payload?.user === state.leaveUser?._id) {
                let userLeaveBalance = JSON.parse(JSON.stringify(state.userLeaveBalance))
                userLeaveBalance = userLeaveBalance.filter(e => e.leavePolicy._id !== action.payload.leavePolicy)
                localState.userLeaveBalance = userLeaveBalance
            }
            return {...state, ...localState}
        }
        default: {
            return state;
        }
    }
}
